<template>
  <speech-and-language
    :add-treatment="addTreatment"
    :complete-appointment="saveAppointmentTabI"
    :delete-location="deleteLocation"
    :delete-relationship="deleteRelationship"
    :delete-treatment="deleteTreatment"
    :edit-location="editLocation"
    :edit-relationship="editRelationship"
    :edit-treatment="editTreatment"
    :full-profile="fullProfileData"
    :get-all-treatments="getAllTreatments"
    :get-appointment-for-tabi="getAppointmentForTabi"
    :get-appointment-info="getAppointmentInfo"
    :get-appointment-locations="getAppointmentLocations"
    :get-appointment-municipalities="getAppointmentMunicipalities"
    :get-appointment-recommendation="getAppointmentRecommendation"
    :get-appointment-specialist-signature="getAppointmentSpecialistSignature"
    :get-discipline-types="getServices"
    :get-frequency-type="getFrequencyType"
    :get-location-types="getLocationTypes"
    :get-locations="getLocations"
    :get-municipalities="getMunicipalities"
    :get-recommendation-reason="getRecommendationReason"
    :get-recommendation-reason-register="getRecommendationReasonRegister"
    :get-referral-reason="getReferralReason"
    :get-relationship-types="getRelationshipTypes"
    :get-relationships="getRelationships"
    :get-service-modalities="getServiceModalities"
    :get-specialist-by-location="getSpecialistByLocation"
    :get-specialist-practitioners="getSpecialistPractitioners"
    :get-tab-sections="getTabSections"
    :get-therapy-durations="getTherapyDurations"
    :get-therapy-period="getTherapyPeriod"
    :save-appointment-specialist-signature="saveAppointmentSpecialistSignature"
    :save-location="saveLocation"
    :save-no-recommendation="saveNoRecommendation"
    :save-recommendation="saveRecommendation"
    :save-relationship="saveRelationship"
    :save-tab-sections="saveTabSections"
    :submit-appointment-tabs="submitAppointmentTabs"
  />
</template>

<script>
import { SpeechAndLanguage } from 'appointment-management';
import {
  // Tab I
  getAppointmentInfo as _getAppointmentInfo,
  getSpecialistPractitioners as _getSpecialistPractitioners,
  getReferralReason as _getReferralReason,
  getAppointmentMunicipalities as _getAppointmentMunicipalities,
  getAppointmentLocations as _getAppointmentLocations,
  getSpecialistByLocation as _getSpecialistByLocation,
  getRelationships as _getRelationships,
  saveRelationship as _saveRelationship,
  deleteRelationship as _deleteRelationship,
  editRelationship as _editRelationship,
  getLocations as _getLocations,
  saveLocation as _saveLocation,
  editLocation as _editLocation,
  deleteLocation as _deleteLocation,
  // Tab III
  getAllTreatments as _getAllTreatments,
  addTreatment as _addTreatment,
  editTreatment as _editTreatment,
  deleteTreatment as _deleteTreatment,
  getServices as _getServices,
} from '@/modules/provider/api';

import {
  // Tab I
  getAppointmentForTabI as _getAppointmentForTabI,
  saveAppointmentTabI as _saveAppointmentTabI,
  // Tab X
  getAppointmentInterventionRecommendation as _getAppointmentRecommendation,
  saveNoInterventionRecommendation as _saveNoRecommendation,
  saveInterventionRecommendation as _saveRecommendation,
  // General
  saveTabSections as _saveTabSections,
  getTabSections as _getTabSections,
  submitAppointmentTabs as _submitAppointmentTabs,
  // Tab XI
  saveAppointmentSpecialistSignature as _saveAppointmentSpecialistSignature,
  getAppointmentSpecialistSignature as _getAppointmentSpecialistSignature,
} from '@/modules/appointmentManagement/api.js';

import {
  getPeiCode as _getPeiCode,
  // Tab III
  getFrequencyType as _getFrequencyType,
  getTherapyDurations as _getTherapyDurations,
  getServiceModalities as _getServiceModalities,
  // Tab X
  getTherapyPeriod as _getTherapyPeriod,
  getRecommendationReason as _getRecommendationReason,
  getRecommendationReasonRegister as _getRecommendationReasonRegister,
} from '@/modules/shared/code.api.js';

import { getMunicipalities as _getMunicipalities } from '@/modules/shared/location.api';

import { mapGetters } from 'vuex';
import { name as userModuleName } from '@/modules/user/store';

export default {
  name: 'SpeechAndLanguageWrapper',
  components: {
    SpeechAndLanguage,
  },
  computed: {
    ...mapGetters(userModuleName, ['fullProfile']),
    fullProfileData() {
      return this.fullProfile;
    },
  },
  methods: {
    // Tab I
    saveAppointmentTabI(params) {
      return _saveAppointmentTabI(params);
    },
    getAppointmentForTabi(clientAppointmentId) {
      return _getAppointmentForTabI(clientAppointmentId);
    },
    getLocations(clientAppointmentId) {
      return _getLocations(clientAppointmentId);
    },
    saveLocation(id, data) {
      return _saveLocation(id, data);
    },
    deleteLocation(id) {
      return _deleteLocation(id);
    },
    editLocation(id, data) {
      return _editLocation(id, data);
    },
    getLocationTypes() {
      return _getPeiCode('AddressType', true);
    },
    getMunicipalities() {
      return _getMunicipalities({ academicYearId: 0 });
    },
    getRelationships(clientAppointmentId) {
      return _getRelationships(clientAppointmentId);
    },
    saveRelationship(id, data) {
      return _saveRelationship(id, data);
    },
    deleteRelationship(id) {
      return _deleteRelationship(id);
    },
    editRelationship(id, data) {
      return _editRelationship(id, data);
    },
    getRelationshipTypes() {
      return _getPeiCode('Relationship');
    },
    getAppointmentInfo(id) {
      return _getAppointmentInfo(id);
    },
    getReferralReason(appointmentId, studentSieId) {
      return _getReferralReason(appointmentId, studentSieId);
    },
    getAppointmentMunicipalities(
      fiscalYearId,
      companyId,
      disciplineTypeCod,
      serviceTypeCode,
      locationId
    ) {
      return _getAppointmentMunicipalities(
        fiscalYearId,
        companyId,
        disciplineTypeCod,
        serviceTypeCode,
        locationId
      );
    },
    getAppointmentLocations(
      fiscalYearId,
      companyId,
      disciplineTypeCod,
      serviceTypeCode,
      locationAddressMunicipalityId
    ) {
      return _getAppointmentLocations(
        fiscalYearId,
        companyId,
        disciplineTypeCod,
        serviceTypeCode,
        locationAddressMunicipalityId
      );
    },
    getSpecialistByLocation(
      fiscalYearId,
      companyId,
      disciplineTypeCod,
      serviceTypeCode,
      locationFiscalYearId
    ) {
      return _getSpecialistByLocation(
        fiscalYearId,
        companyId,
        disciplineTypeCod,
        serviceTypeCode,
        locationFiscalYearId
      );
    },
    getSpecialistPractitioners(disciplineTypeCod, specialistLocationId) {
      return _getSpecialistPractitioners(
        disciplineTypeCod,
        specialistLocationId
      );
    },
    // Tab III
    getAllTreatments(clientAppointmentId) {
      return _getAllTreatments(clientAppointmentId);
    },
    addTreatment(clientAppointmentId, parameters) {
      return _addTreatment(clientAppointmentId, parameters);
    },
    editTreatment(treatmentId, parameters) {
      return _editTreatment(treatmentId, parameters);
    },
    deleteTreatment(treatmentId) {
      return _deleteTreatment(treatmentId);
    },
    getServices(serviceTypeIds, categories) {
      return _getServices(serviceTypeIds, categories);
    },
    getFrequencyType() {
      return _getFrequencyType();
    },
    getTherapyDurations() {
      return _getTherapyDurations();
    },
    getServiceModalities() {
      return _getServiceModalities();
    },
    // Tab X
    getTherapyPeriod() {
      return _getTherapyPeriod();
    },
    getRecommendationReason() {
      return _getRecommendationReason();
    },
    getRecommendationReasonRegister(reasonId) {
      return _getRecommendationReasonRegister(reasonId);
    },
    getAppointmentRecommendation(clientAppointmentId) {
      return _getAppointmentRecommendation(clientAppointmentId);
    },
    saveNoRecommendation(clientAppointmentId, params) {
      return _saveNoRecommendation(clientAppointmentId, params);
    },
    saveRecommendation(clientAppointmentId, params) {
      return _saveRecommendation(clientAppointmentId, params);
    },
    // Tab XI
    saveAppointmentSpecialistSignature(clientAppointmentId, params) {
      return _saveAppointmentSpecialistSignature(clientAppointmentId, params);
    },
    getAppointmentSpecialistSignature(clientAppointmentId) {
      return _getAppointmentSpecialistSignature(clientAppointmentId);
    },
    // General
    saveTabSections(clientAppointmentId, data) {
      return _saveTabSections(clientAppointmentId, data);
    },
    getTabSections(clientAppointmentId, tabIdx) {
      return _getTabSections(clientAppointmentId, tabIdx + 1);
    },
    submitAppointmentTabs(clientAppointmentId) {
      return _submitAppointmentTabs(clientAppointmentId);
    },
  },
};
</script>
